import { Col, message, Row, Form as FormInitial, Select, Collapse } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    TextAreaItem,
    InputNumberItem,
    SelectItem
} from "../../../../Components/Items";
import { MinusCircleOutlined, PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Panel } = Collapse;

const SeccionTitulo = ({ numero, titulo, color, nota, derecha }) => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            flexWrap: "wrap",
            marginBottom: 10,
            paddingBottom: 6,
            borderBottom: "2px solid " + color + "40",
        }}
    >
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            <span
            
                style={{
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    background: color,
                    color: "#fff",
                    fontSize: 11,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "none", 
                }}
            >
                {numero}
            </span>
            <span
                style={{
                    fontSize: 13,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    color: "#3c4b53",
                }}
            >
                {titulo}
            </span>
            {nota ? (
                <span style={{ fontSize: 11.5, color: "#7b8a92" }}>{nota}</span>
            ) : null}
        </div>
        {derecha ? <div>{derecha}</div> : null}
    </div>
);

const SubTitulo = ({ children }) => (
    <div
        style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            color: "#262626",
            borderBottom: "1px solid #f0f0f0",
            paddingBottom: 4,
            marginBottom: 6,
        }}
    >
        {children}
    </div>
);

const AyudaBloque = ({ numero, titulo, children }) => (
    <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 5 }}>
            <span
                style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "#00BFD6",
                    color: "#fff",
                    fontSize: 10.5,
                    fontWeight: 700,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flex: "none",
                }}
            >
                {numero}
            </span>
            <span
                style={{
                    fontSize: 11.5,
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    color: "#3c4b53",
                }}
            >
                {titulo}
            </span>
        </div>
        {children}
    </div>
);

const AyudaPuntos = ({ children }) => (
    <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, lineHeight: 1.55, color: "#5a6a72" }}>
        {children}
    </ul>
);

const AyudaEjemplo = ({ children }) => (
    <div
        style={{
            marginTop: 6,
            background: "#f6f8f9",
            border: "1px solid #eceff0",
            borderRadius: 8,
            padding: "6px 9px",
            fontSize: 11.5,
            lineHeight: 1.6,
            color: "#5a6a72",
        }}
    >
        {children}
    </div>
);

const AyudaAviso = ({ children }) => (
    <div
        style={{
            marginTop: 6,
            background: "#fff6f6",
            border: "1px solid #ffe0e0",
            borderRadius: 8,
            padding: "5px 9px",
            fontSize: 11.5,
            lineHeight: 1.5,
            color: "#c0392b",
        }}
    >
        <b>Asegúrate:</b> {children}
    </div>
);

class AgregarFamiliaImplementacion extends Component {
    formRef = React.createRef();
    contenidoRef = React.createRef();
    state = {
        loading: false,
        objetoCuentaContable: null,
        todasCuentaContable: null,
        objetoCuentaContableIE: null,
        todasCuentaContableIE: null,
        modalAgregarCuentaContable: false,
        // Catálogo global de insumos, para no recapturar uno que ya existe.
        todosInsumos: [],
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarTodo();
            if (this.contenidoRef.current) this.contenidoRef.current.scrollTop = 0;
        }
    }
    cerrarAgregarFamiliaImplementacion(codigo) {
        this.props.cerrarAgregarFamiliaImplementacion(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "insumosImplementacion/selectTodosInsumosImplementacion",
                { page: 1, pageSize: 1000, valor: 1 },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                const datos = res.data.success === 2 ? res.data.data || [] : [];
                this.setState({
                    todosInsumos: datos.filter((insumo) => insumo.estado === 1),
                });
            })
            .catch(() => this.setState({ todosInsumos: [] }));
        this.setState({ loading: false });
    }
    // Del catálogo solo se copian los datos: el insumo se guarda embebido en
    // esta familia, así que si luego cambia en el catálogo esta copia no se
    // entera. Se dejan fuera _id, numero, serie y familiaImplementacionIds.
    insumoDelCatalogo(insumoId) {
        const insumo = this.state.todosInsumos.find((item) => item._id === insumoId);
        if (!insumo) return null;
        const soloNombres = (lista) =>
            (lista || [])
                .map((item) => ({ nombre: item?.nombre }))
                .filter((item) => item.nombre);
        return {
            clave: insumo.clave,
            unidad: insumo.unidad,
            descripcion: insumo.descripcion,
            descripcionLarga: insumo.descripcionLarga,
            costo: insumo.costo,
            venta: !!insumo.venta,
            compra: !!insumo.compra,
            inventariable: !!insumo.inventariable,
            impuestos: soloNombres(insumo.impuestos),
            retenciones: soloNombres(insumo.retenciones),
        };
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "familiasImplementacion/agregarFamiliaImplementacion",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una familia");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarFamiliaImplementacion(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede registrar la familia");
                } else {
                    message.error("Hubo un error y la familia no se registro");
                }
            });
    }

    renderEncabezadoCuentas = () => {
        const estilo = {
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            color: "#7b8a92",
        };
        return (
            <Row gutter={8} style={{ padding: "0 6px", marginBottom: 4 }}>
                <Col span={8}>
                    <span style={estilo}>Cuenta contable</span>
                </Col>
                <Col span={7}>
                    <span style={estilo}>Clave</span>
                </Col>
                <Col span={9}>
                    <span style={estilo}>Descripción</span>
                </Col>
            </Row>
        );
    };

    renderCuentaBlock = (prefix, titulo, indice) => (
        <Row
            gutter={8}
            align="middle"
            style={{
                background: indice % 2 === 0 ? "#fafbfc" : "#fff",
                borderRadius: 8,
                padding: "2px 6px",
                marginBottom: 3,
            }}
        >
            <Col span={8}>
                <span style={{ fontSize: 12, fontWeight: 600, color: "#3c4b53" }}>
                    {titulo}
                </span>
            </Col>
            <Col span={7}>
                <FormItem name={[prefix, "cuenta"]} margin pattern>
                    <InputNumberItem cuentaContable placeholder="Ej. 601-01" />
                </FormItem>
            </Col>
            <Col span={9}>
                <FormItem name={[prefix, "descripcion"]} margin pattern>
                    <InputItem placeholder="Descripción de la cuenta" />
                </FormItem>
            </Col>
        </Row>
    );

    renderSwitchInsumo = (name, campo, etiqueta, disabled) => (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                fontSize: 11.5,
                fontWeight: 600,
                color: disabled ? "#b6c0c5" : "#5a6a72",
            }}
        >
            {etiqueta}
            <FormItem
                name={[name, campo]}
                initialValue={false}
                valuePropName="checked"
                noStyle
            >
                <SwitchItem size="small" disabled={disabled} />
            </FormItem>
        </span>
    );

    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Familia Implementacion"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarFamiliaImplementacion.bind(this)}
                    width={window.innerWidth > 1200 ? "70%" : "95%"}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarFamiliaImplementacion"
                        layoutForm="vertical"
                        bottom={
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <ButtonItem type="primary" cyan htmlType="submit">
                                    Agregar
                                </ButtonItem>
                            </div>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <div
                            ref={this.contenidoRef}
                            className="scrollbar-pequeña"
                            style={{
                                maxHeight: "calc(100vh - 310px)",
                                minHeight: 240,
                                overflowY: "auto",
                                overflowX: "hidden",
                                paddingRight: 6,
                            }}
                        >
                            {/* ========== 1 · FAMILIA ========== */}
                            <div
                                style={{
                                    background: "#fff",
                                    border: "1px solid #eef1f2",
                                    borderRadius: 12,
                                    padding: "10px 14px 6px 14px",
                                    marginBottom: 14,
                                }}
                            >
                                <SeccionTitulo numero={1} titulo="Familia" color="#00BFD6" />
                                <Row gutter={[12, 0]}>
                                    <Col xs={24} sm={12} md={10}>
                                        <FormItem name="nombre" label="Nombre" required margin pattern>
                                            <InputItem placeholder="Nombre" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={12} md={8}>
                                        <FormItem
                                            name="tipoDeFamilia"
                                            label="Tipo de Familia"
                                            max={100}
                                            margin
                                            pattern
                                        >
                                            <InputItem placeholder="Tipo de Familia" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <FormItem
                                            label="Gasto no deducible"
                                            name="gastoNoDeducible"
                                            margin
                                            initialValue={false}
                                            valuePropName="checked"
                                        >
                                            <SwitchItem />
                                        </FormItem>
                                    </Col>
                                    <Col span={24}>
                                        <FormItem name="descripcion" label="Descripción" margin pattern>
                                            <TextAreaItem
                                                placeholder="Descripción"
                                                autoSize={{ minRows: 2, maxRows: 4 }}
                                            />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </div>

                            {/* ========== 2 · CUENTAS CONTABLES ========== */}
                            <div
                                style={{
                                    background: "#fff",
                                    border: "1px solid #eef1f2",
                                    borderRadius: 12,
                                    padding: "10px 14px 6px 14px",
                                    marginBottom: 14,
                                }}
                            >
                                <SeccionTitulo
                                    numero={2}
                                    titulo="Cuentas contables"
                                    color="#00BFD6"
                                    nota="Captura únicamente 2 niveles (ej. 601-01). El 3er nivel se genera automáticamente."
                                />
                                <Row gutter={[18, 0]}>
                                    <Col xs={24} lg={12}>
                                        {this.renderEncabezadoCuentas()}
                                        {this.renderCuentaBlock("cuentaGastoNoDeducible", "Gasto no deducible", 0)}
                                        {this.renderCuentaBlock("cuentaInventario", "Inventario", 1)}
                                        {this.renderCuentaBlock("cuentaCostoGasto", "Costo / gasto", 2)}
                                        {this.renderCuentaBlock("cuentaTransito", "Tránsito", 3)}
                                    </Col>
                                    <Col xs={24} lg={12}>
                                        {this.renderEncabezadoCuentas()}
                                        {this.renderCuentaBlock("cuentaAjusteInventario", "Ajuste inventario", 0)}
                                        {this.renderCuentaBlock("cuentaIngresoContado", "Ingreso contado", 1)}
                                        {this.renderCuentaBlock("cuentaIngresoCredito", "Ingreso crédito", 2)}
                                        {this.renderCuentaBlock("cuentaTerceros", "Terceros", 3)}
                                    </Col>
                                </Row>
                            </div>

                            {/* ========== 3 · INSUMOS ========== */}
                            <div
                                style={{
                                    background: "#fff",
                                    border: "1px solid #eef1f2",
                                    borderRadius: 12,
                                    padding: "10px 14px 6px 14px",
                                    marginBottom: 14,
                                }}
                            >
                                <FormInitial.List name="insumos">
                                    {(fields, { add, remove }) => (
                                        <>
                                            <SeccionTitulo
                                                numero={3}
                                                titulo="Insumos"
                                                color="#FF6A0D"
                                                nota={
                                                    fields.length > 0
                                                        ? fields.length +
                                                          (fields.length === 1 ? " insumo" : " insumos")
                                                        : null
                                                }
                                            />

                                            {/* Atajo: trae un insumo del catálogo ya lleno */}
                                            <div style={{ marginBottom: 12 }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 8,
                                                        flexWrap: "wrap",
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: 12,
                                                            fontWeight: 700,
                                                            letterSpacing: 0.4,
                                                            textTransform: "uppercase",
                                                            color: "#3c4b53",
                                                        }}
                                                    >
                                                        Del catálogo
                                                    </span>
                                                    <span style={{ fontSize: 11.5, color: "#7b8a92" }}>
                                                        (Opcional)
                                                    </span>
                                                </div>
                                                <SelectItem
                                                    placeholder="Agregar un insumo ya guardado"
                                                    width="100%"
                                                    noFocusSiguiente
                                                    value={undefined}
                                                    onChange={(insumoId) => {
                                                        const datos = this.insumoDelCatalogo(insumoId);
                                                        if (!datos) return;
                                                        add(datos);
                                                        message.success(
                                                            "Se agregó " +
                                                                (datos.clave ? datos.clave + " · " : "") +
                                                                (datos.descripcion || "")
                                                        );
                                                    }}
                                                >
                                                    {this.state.todosInsumos.map((insumo) => (
                                                        <Option key={insumo._id} value={insumo._id}>
                                                            {(insumo.clave ? insumo.clave + " · " : "") +
                                                                (insumo.descripcion || "") +
                                                                (insumo.unidad ? " · " + insumo.unidad : "")}
                                                        </Option>
                                                    ))}
                                                </SelectItem>
                                            </div>

                                            {fields.length === 0 ? (
                                                <div
                                                    className="card-punteada"
                                                    style={{
                                                        textAlign: "center",
                                                        color: "#7b8a92",
                                                        fontSize: 12.5,
                                                        marginBottom: 4,
                                                    }}
                                                >
                                                    <div style={{ marginBottom: 10 }}>
                                                        Aún no has agregado insumos a esta familia.
                                                    </div>
                                                    <ButtonItem
                                                        naranjaB
                                                        lessTime
                                                        onClick={() => add()}
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Agregar insumo
                                                    </ButtonItem>
                                                </div>
                                            ) : null}

                                            {fields.map(({ name }, idx) => (
                                                <div
                                                    key={idx}
                                                    style={{
                                                        border: "1px solid #f0f0f0",
                                                        borderRadius: 12,
                                                        marginBottom: 12,
                                                        background: "#fff",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            gap: 12,
                                                            flexWrap: "wrap",
                                                            background: "#fff8f3",
                                                            borderBottom: "1px solid #ffe4d1",
                                                            padding: "5px 10px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontSize: 11.5,
                                                                fontWeight: 700,
                                                                letterSpacing: 0.4,
                                                                textTransform: "uppercase",
                                                                color: "#FF6A0D",
                                                            }}
                                                        >
                                                            Insumo #{idx + 1}
                                                        </span>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 14,
                                                                flexWrap: "wrap",
                                                            }}
                                                        >
                                                            {this.renderSwitchInsumo(name, "venta", "Venta", true)}
                                                            {this.renderSwitchInsumo(name, "compra", "Compra", false)}
                                                            {this.renderSwitchInsumo(name, "inventariable", "Inventariable", false)}
                                                            <MinusCircleOutlined
                                                                onClick={() => remove(name)}
                                                                style={{ color: "#ff4d4f", fontSize: 15, cursor: "pointer" }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div style={{ padding: "8px 12px 10px 12px" }}>
                                                        <Row gutter={[12, 0]}>
                                                            <Col xs={24} sm={12} md={5}>
                                                                <FormItem name={[name, "clave"]} label="Clave" margin pattern>
                                                                    <InputItem placeholder="Clave" />
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={12} md={7}>
                                                                <FormItem name={[name, "unidad"]} label="Unidad" margin pattern>
                                                                    <InputItem placeholder="Ej. PZA, KG (preferible SAT)" />
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={12} md={8}>
                                                                <FormItem name={[name, "descripcion"]} label="Descripción" margin pattern>
                                                                    <InputItem placeholder="Descripción" />
                                                                </FormItem>
                                                            </Col>
                                                            <Col xs={24} sm={12} md={4}>
                                                                <FormItem name={[name, "costo"]} label="Costo" margin pattern>
                                                                    <InputItem placeholder="0" />
                                                                </FormItem>
                                                            </Col>
                                                        </Row>

                                                        <Row gutter={[12, 10]} style={{ marginTop: 4 }}>
                                                            {/* ---------- Descripción larga ---------- */}
                                                            <Col xs={24} md={10}>
                                                                <FormItem
                                                                    name={[name, "descripcionLarga"]}
                                                                    label="Descripción larga"
                                                                    margin
                                                                    pattern
                                                                >
                                                                    <TextAreaItem
                                                                        placeholder="Descripción larga"
                                                                        autoSize={{ minRows: 2, maxRows: 4 }}
                                                                    />
                                                                </FormItem>
                                                            </Col>

                                                            {/* ---------- Impuestos ---------- */}
                                                            <Col xs={24} md={7}>
                                                                <FormInitial.List name={[name, "impuestos"]}>
                                                                    {(impFields, { add: addImp, remove: removeImp }) => (
                                                                        <>
                                                                            <SubTitulo>Impuestos</SubTitulo>
                                                                            <div style={{ marginBottom: impFields.length > 0 ? 6 : 0 }}>
                                                                                <ButtonItem
                                                                                    cyan
                                                                                    lessTime
                                                                                    onClick={() => addImp()}
                                                                                    icon={<PlusOutlined />}
                                                                                >
                                                                                    Agregar impuesto
                                                                                </ButtonItem>
                                                                            </div>
                                                                            {impFields.map(({ name: impName }, impIdx) => (
                                                                                <Row gutter={6} align="middle" key={impIdx} style={{ marginBottom: 3 }}>
                                                                                    <Col flex="auto">
                                                                                        <FormItem name={[impName, "nombre"]} margin pattern>
                                                                                            <SelectItem placeholder="Ej. IVA">
                                                                                                <Option value="ISH 15%">ISH 15%</Option>
                                                                                                <Option value="ISH 10%">ISH 10%</Option>
                                                                                                <Option value="ISH 6%">ISH 6%</Option>
                                                                                                <Option value="ISH 5%">ISH 5%</Option>
                                                                                                <Option value="ISH 4%">ISH 4%</Option>
                                                                                                <Option value="ISH 3.75%">ISH 3.75%</Option>
                                                                                                <Option value="ISH 3.5%">ISH 3.5%</Option>
                                                                                                <Option value="ISH 3%">ISH 3%</Option>
                                                                                                <Option value="ISH 2.5%">ISH 2.5%</Option>
                                                                                                <Option value="ISH 2%">ISH 2%</Option>

                                                                                                <Option value="IEPS 160%">IEPS 160%</Option>
                                                                                                <Option value="IEPS 53%">IEPS 53%</Option>
                                                                                                <Option value="IEPS 50%">IEPS 50%</Option>
                                                                                                <Option value="IEPS 30.40%">IEPS 30.40%</Option>
                                                                                                <Option value="IEPS 30%">IEPS 30%</Option>
                                                                                                <Option value="IEPS 26.5%">IEPS 26.5%</Option>
                                                                                                <Option value="IEPS 25%">IEPS 25%</Option>
                                                                                                <Option value="IEPS 9%">IEPS 9%</Option>
                                                                                                <Option value="IEPS 8%">IEPS 8%</Option>
                                                                                                <Option value="IEPS 7%">IEPS 7%</Option>
                                                                                                <Option value="IEPS 6%">IEPS 6%</Option>
                                                                                                <Option value="IEPS 3%">IEPS 3%</Option>

                                                                                                <Option value="IVA 16% (Especial)">IVA 16% (Especial)</Option>
                                                                                                <Option value="IVA Exento">IVA Exento</Option>
                                                                                                <Option value="IVA 0%">IVA 0%</Option>
                                                                                                <Option value="IVA 8%">IVA 8%</Option>
                                                                                                <Option value="IVA 16%">IVA 16%</Option>
                                                                                            </SelectItem>
                                                                                        </FormItem>
                                                                                    </Col>
                                                                                    <Col flex="22px" style={{ textAlign: "center" }}>
                                                                                        <MinusCircleOutlined
                                                                                            onClick={() => removeImp(impName)}
                                                                                            style={{ color: "#ff4d4f", cursor: "pointer" }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </FormInitial.List>
                                                            </Col>

                                                            {/* ---------- Retenciones ---------- */}
                                                            <Col xs={24} md={7}>
                                                                <FormInitial.List name={[name, "retenciones"]}>
                                                                    {(retFields, { add: addRet, remove: removeRet }) => (
                                                                        <>
                                                                            <SubTitulo>Retenciones</SubTitulo>
                                                                            <div style={{ marginBottom: retFields.length > 0 ? 6 : 0 }}>
                                                                                <ButtonItem
                                                                                    cyan
                                                                                    lessTime
                                                                                    onClick={() => addRet()}
                                                                                    icon={<PlusOutlined />}
                                                                                >
                                                                                    Agregar retención
                                                                                </ButtonItem>
                                                                            </div>
                                                                            {retFields.map(({ name: retName }, retIdx) => (
                                                                                <Row gutter={6} align="middle" key={retIdx} style={{ marginBottom: 3 }}>
                                                                                    <Col flex="auto">
                                                                                        <FormItem name={[retName, "nombre"]} margin pattern>
                                                                                            <SelectItem placeholder="Ej. ISR">
                                                                                                <Option value="Ret. 4% Fletes">Ret. 4% Fletes</Option>
                                                                                                <Option value="Ret. ISR 1.25% RESICO Servicios Profesionales">
                                                                                                    Ret. ISR 1.25% RESICO Servicios Profesionales
                                                                                                </Option>
                                                                                                <Option value="Ret. 1.25% ISR RESICO Arrendamiento">
                                                                                                    Ret. 1.25% ISR RESICO Arrendamiento
                                                                                                </Option>
                                                                                                <Option value="Retención ISR 10% Servicios Profesionales">
                                                                                                    Retención ISR 10% Servicios Profesionales
                                                                                                </Option>
                                                                                                <Option value="Retención ISR 10% Arrendamiento">
                                                                                                    Retención ISR 10% Arrendamiento
                                                                                                </Option>
                                                                                                <Option value="Retención IVA 10.6667%">
                                                                                                    Retención IVA 10.6667%
                                                                                                </Option>
                                                                                            </SelectItem>
                                                                                        </FormItem>
                                                                                    </Col>
                                                                                    <Col flex="22px" style={{ textAlign: "center" }}>
                                                                                        <MinusCircleOutlined
                                                                                            onClick={() => removeRet(retName)}
                                                                                            style={{ color: "#ff4d4f", cursor: "pointer" }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            ))}
                                                                        </>
                                                                    )}
                                                                </FormInitial.List>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            ))}

                                            {fields.length > 0 ? (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 2,
                                                        marginBottom: 6,
                                                    }}
                                                >
                                                    <ButtonItem
                                                        naranjaB
                                                        lessTime
                                                        onClick={() => add()}
                                                        icon={<PlusOutlined />}
                                                    >
                                                        Agregar insumo
                                                    </ButtonItem>
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </FormInitial.List>
                            </div>
                        </div>

                        {/* ========== Ayuda: proceso de implementación ========== */}
                        <Collapse
                            ghost
                            expandIconPosition="right"
                            style={{
                                background: "#f7fbfc",
                                border: "1px solid #ddeff2",
                                borderRadius: 10,
                                marginTop: 6,
                            }}
                        >
                            <Panel
                                key="proceso"
                                header={
                                    <span style={{ fontSize: 12.5, fontWeight: 700, color: "#0d7f8c" }}>
                                        <InfoCircleOutlined style={{ marginRight: 7 }} />
                                        Proceso de implementación automática
                                    </span>
                                }
                            >
                                <div
                                    className="scrollbar-pequeña"
                                    style={{ maxHeight: "40vh", overflowY: "auto", paddingRight: 4 }}
                                >
                                    <Row gutter={[18, 0]}>
                                        <Col xs={24} md={12}>
                                            <AyudaBloque numero={1} titulo="Cuentas contables">
                                                <AyudaPuntos>
                                                    <li>
                                                        Las cuentas se dan de alta hasta segundo nivel solo si no
                                                        existen; si ya existen, el sistema no realiza ninguna acción.
                                                    </li>
                                                    <li>El tercer nivel se genera automáticamente tomando el consecutivo.</li>
                                                    <li>
                                                        Si una cuenta se repite dentro de la familia, solamente se da de
                                                        alta una vez.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaEjemplo>
                                                    <b style={{ color: "#3c4b53" }}>Ejemplo</b>
                                                    <br />
                                                    Si se envía la cuenta 601-01-001:
                                                    <br />
                                                    1. Valida que 601 y 601-01 existan.
                                                    <br />
                                                    2. Si no existen, los crea.
                                                    <br />
                                                    3. Genera el tercer nivel (ej. 601-01-003 si es el consecutivo).
                                                </AyudaEjemplo>
                                                <AyudaAviso>
                                                    Captura las cuentas únicamente hasta segundo nivel (ejemplo: 601-01).
                                                </AyudaAviso>
                                            </AyudaBloque>

                                            <AyudaBloque numero={2} titulo="Familia">
                                                <AyudaPuntos>
                                                    <li>
                                                        La familia se da de alta utilizando las cuentas contables de
                                                        tercer nivel generadas.
                                                    </li>
                                                    <li>Se le asigna el nombre y la descripción indicados.</li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Revisa el nombre y la descripción: si coinciden con una familia
                                                    existente, no se vuelve a crear.
                                                </AyudaAviso>
                                            </AyudaBloque>
                                        </Col>

                                        <Col xs={24} md={12}>
                                            <AyudaBloque numero={3} titulo="Insumos">
                                                <AyudaPuntos>
                                                    <li>Los insumos se dan de alta ligados a la familia.</li>
                                                    <li>Los impuestos y las retenciones se buscan por nombre.</li>
                                                    <li>
                                                        Las unidades se buscan primero por clave SAT y después por
                                                        nombre de unidad.
                                                    </li>
                                                    <li>
                                                        Recomendación: coloca siempre la unidad con clave SAT para que
                                                        el sistema la detecte automáticamente.
                                                    </li>
                                                    <li>
                                                        Nota: actualmente los insumos no se pueden marcar como de venta.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Los impuestos y las retenciones deben existir con exactamente el
                                                    mismo nombre, y las unidades deben estar dadas de alta.
                                                </AyudaAviso>
                                            </AyudaBloque>

                                            <AyudaBloque numero={4} titulo="Consideraciones">
                                                <AyudaPuntos>
                                                    <li>El sistema tiene múltiples validaciones para evitar duplicidad.</li>
                                                    <li>
                                                        Si la familia ya existe por nombre y descripción, únicamente se
                                                        dan de alta los insumos.
                                                    </li>
                                                    <li>
                                                        Si los insumos ya existen por clave y descripción, no se vuelven
                                                        a crear.
                                                    </li>
                                                    <li>
                                                        Las cuentas contables hasta segundo nivel no se duplican si ya
                                                        existen.
                                                    </li>
                                                </AyudaPuntos>
                                                <AyudaAviso>
                                                    Verifica cuidadosamente cuentas, familias, impuestos, retenciones y
                                                    unidades antes de ejecutar el proceso.
                                                </AyudaAviso>
                                            </AyudaBloque>
                                        </Col>
                                    </Row>
                                </div>
                            </Panel>
                        </Collapse>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgregarFamiliaImplementacion);
